export const overrides = {
    MuiFormLabel: {
        root: {
            '&[class*="NeptuneFormLabel-inline"]': {
                position: 'static',
                transform: 'none',
                lineHeight: 1.3,
                paddingTop: 7,
                paddingBottom: 7
            },
            '&[class*="NeptuneFormLabel-secondary"]': {
                display: 'flex',
                paddingTop: 9,
                paddingBottom: 7,
                fontSize: 14,
                letterSpacing: '0.06em',
                textTransform: 'uppercase'
            }
        }
    }
};
